//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDictTreeListApi } from '@/api/form';
export default {
  name: 'CustomerForm',
  components: {
    uploadFile: function uploadFile() {
      return import('@/components/form-common/oa-upload');
    },
    ueditorFrom: function ueditorFrom() {
      return import('@/components/form-common/oa-wangeditor');
    },
    manageRange: function manageRange() {
      return import('@/components/form-common/select-manageRange');
    },
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    },
    selectLabel: function selectLabel() {
      return import('@/components/form-common/select-label');
    },
    selectOne: function selectOne() {
      return import('@/components/form-common/select-one');
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    timeValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: ''
    },
    btnShow: {
      type: Boolean,
      default: true
    },
    is_develp: {
      type: Boolean,
      default: false
    },
    isTimeArray: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      drawer: true,
      saveLoading: false,
      ruleForm: {},
      form: {},
      rule: {},
      autosize: {
        minRows: 6
      },
      pickerOptions: this.$pickerOptionsTimeEle,
      activeIndex: null,
      fileParams: {
        relation_type: 'client',
        // 上传类型 客户：client  合同：contract
        relation_id: 0,
        // 关联id合同id或者别的id
        way: 2,
        eid: 0
      },
      member: ['user_id', 'update_user_id', 'owner_user_id', 'creator', 'salesman'],
      heightInputRole: 32,
      memberShow: false,
      userList: [],
      addressList: [],
      timeVal: [],
      labelList: [],
      // 选中客户标签
      cityList: []
    };
  },
  watch: {
    list: {
      handler: function handler(newVal) {
        var _this = this;
        newVal.forEach(function (item, index) {
          if (typeof item.value != 'undefined') {
            _this.ruleForm[item.field_name_en] = item.value;
          }
        });
      },
      deep: true,
      immediate: true
    },
    timeValue: {
      handler: function handler(newVal) {
        this.timeVal = newVal;
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    this.getCityList();
  },
  methods: {
    reset: function reset() {
      var _this2 = this;
      this.timeVal = [];
      this.ruleForm.scope_frame = 'all';
      this.list.map(function (item) {
        if (Object.hasOwnProperty.call(item, 'value')) {
          _this2.ruleForm[item.field_name_en] = item.value;
        }
      });
    },
    // 选择时间区域
    onchangeTime: function onchangeTime(e, val) {
      if (val.data_dict == null) {
        this.ruleForm[val.field_name_en] = '';
        this.$emit('handleEmit', this.ruleForm);
      } else {
        if (typeof val.data_dict === 'string') {
          this.ruleForm[val.field_name_en] = val.data_dict;
        } else {
          this.ruleForm[val.field_name_en] = val.data_dict.join('-');
        }
        this.$emit('handleEmit', this.ruleForm);
      }
    },
    handleEmit: function handleEmit(val, item) {
      this.$forceUpdate();
      var form = JSON.parse(JSON.stringify(this.ruleForm));
      if (val && !this.is_develp && item) {
        form[item.field_name_en].forEach(function (value, index) {
          form[item.field_name_en][index] = '[' + value.join(',') + ']';
        });
      }
      this.$emit('handleEmit', form);
    },
    // 打开一对一表格
    handleTable: function handleTable(row, index) {
      this.activeIndex = index;
      this.$refs.tableDialog.openBox(row.id);
    },
    oneLabel: function oneLabel(index) {
      this.list[index].data_dict = [];
      var key = this.list[index].field_name_en;
      this.ruleForm[key] = '';
      this.$emit('handleEmit', this.ruleForm);
    },
    resetSearch: function resetSearch() {
      var _this3 = this;
      this.labelList = [];
      this.ruleForm.keyword_default = '';
      this.ruleForm = {};
      this.reset();
      if (this.$refs.selectLabel) {
        this.$refs.selectLabel.selectList = [];
      }
      setTimeout(function () {
        _this3.$refs.manageRange && (_this3.type && _this3.type == 0 ? _this3.$refs.manageRange.reset() : _this3.$refs.manageRange[0].reset());
      }, 300);
      this.list.map(function (item) {
        if (['input_select', 'user_id', 'frame_id', 'date_picker', 'date_time_picker', 'monthrange'].includes(item.form_value)) {
          item.data_dict = [];
        }
      });
      this.$emit('resetSearch');
    },
    // 选择人员回调
    getSelectList: function getSelectList(data, val) {
      val.data_dict = data || [];
      this.ruleForm[val.field_name_en] = data[0] ? data[0].value : '';
      this.$emit('handleEmit', this.ruleForm);
    },
    // 选择部门完成回调
    changeMastart: function changeMastart(data, val) {
      val.data_dict = data || [];
      this.ruleForm[val.field_name_en] = data[0] ? data[0].id : '';
      this.$emit('handleEmit', this.ruleForm);
    },
    // 选择一对一回调
    getSelection: function getSelection(data, val) {
      val.data_dict = data || [];
      this.ruleForm[val.field_name_en] = data.id;
      this.$emit('handleEmit', this.ruleForm);
      this.activeIndex = -1;
    },
    // 选中标签回调
    handleLabelConf: function handleLabelConf(data, val) {
      this.ruleForm[val.field_name_en] = data.ids;
      this.$emit('handleEmit', this.ruleForm);
      this.activeIndex = -1;
    },
    getCityList: function getCityList(index) {
      var _this4 = this;
      var obj = {
        type_id: 2
      };
      getDictTreeListApi(obj).then(function (res) {
        var data = res.data,
          status = res.status;
        _this4.addressList = data;
      }).catch(function (error) {
        reject(error);
      });
    },
    changeFrame: function changeFrame(e) {
      this.scope_frame = e;
      this.ruleForm.scope_frame = this.scope_frame;
      this.$emit('handleEmit', this.ruleForm);
    },
    heightInput: function heightInput() {
      var _this5 = this;
      setTimeout(function () {
        var height = _this5.$refs.getHeight[0].clientHeight;
        _this5.heightInputRole = height === 0 ? 36 : height;
      }, 200);
    },
    // 删除客户标签
    cardTag: function cardTag(index, index_s, type) {
      if (type === 1) {
        var _this$list$this$activ;
        // 删除人员
        var key = (_this$list$this$activ = this.list[this.activeIndex]) === null || _this$list$this$activ === void 0 ? void 0 : _this$list$this$activ.field_name_en;
        this.list[index].data_dict = [];
        this.ruleForm[key] = '';
      }
      this.$emit('handleEmit', this.ruleForm);
    }
  }
};